import {createButton} from 'src/library/minigame_client/ui/common/ui';

export default class Settings extends PIXI.Container
{
    constructor(configGame) {

        super();

        let self = this;

        const packFolder = configGame.packFolder;
        const pathRes = "res/" + configGame.pathFolder;
        const screen = configGame.Screen;

        const config = configGame.Settings;

        this.sndBtnClick = sounds.get("res/sounds/btn_click");
        this.sndSelectClick = sounds.get("res/sounds/settings_click");

        this.layerBlockInput = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.layerBlockInput.position.set(0, 0);
        this.layerBlockInput.interactive = true;     // block interactive of overlaid buttons
        this.layerBlockInput.width = screen.resolution.width;
        this.layerBlockInput.height = screen.resolution.height;
        this.layerBlockInput.tint = 0x000000;
        this.layerBlockInput.alpha = 0.7;
        this.addChild(this.layerBlockInput);

        this.background = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "utility_background.png"]);
        this.background.position.set(config.background.pos.x, config.background.pos.y);
        this.background.interactive = true;     // block interactive of overlaid buttons
        this.addChild(this.background);

        this.backgroundTitle = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "title_setting.png"]);
        this.backgroundTitle.position.set(config.backgroundTitle.pos.x, config.backgroundTitle.pos.y);
        this.background.addChild(this.backgroundTitle);

        this.frameSelect = new PIXI.Sprite(PIXI.utils.TextureCache[configGame.pathFolder + "settings_btn_back/down.png"]);
        this.frameSelect.anchor.set(0.5, 0.5);

        this.ind = 0;
        this.indNew = 0;

        this.callbackButtonImg = null;
        this.arrBackgrounds = [];
        const count = config.countImg;
        for (let i = 0; i < count; ++i) {
            const x = config.grid.startPos.x;
            const y = config.grid.startPos.y;
            const xL = config.grid.stepLength.x;
            const yL = config.grid.stepLength.y;

            let pos = {x: x + i % 3 * xL, y: y + Math.floor(i / 3) * yL};

            let button = createButton(this.background, 0, 0, configGame.pathFolder + "settings_btn_back", this.sndSelectClick);
            button.position = pos;
            button.anchor.set(0.5, 0.5);
            button.callback = function() {
                self.indNew = i;
                self.frameSelect.position = pos;
                if (self.callbackButtonImg) self.callbackButtonImg(self.indNew);
            };

            let back = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "back/background_%d.jpg".$(i)]);
            back.position = pos;
            back.scale = config.grid.scale;
            back.anchor.set(0.5, 0.5);
            this.arrBackgrounds.push(back);
        }

        this.background.addChild(this.frameSelect);
        for (let i = 0; i < this.arrBackgrounds.length; ++i) {
            this.background.addChild(this.arrBackgrounds[i]);
        }

        if (this.arrBackgrounds.length > 0)
            this.frameSelect.position = this.arrBackgrounds[0].position;

        this.buttonOk = createButton(this.background, config.buttonOk.pos.x, config.buttonOk.pos.y, packFolder + "ok_settings", this.sndBtnClick);
    };

    terminate () {
        this.removeChildren();
        this.destroy();

        this.background = null;
        this.backgroundTitle = null;
        this.frameSelect = null;
        this.buttonOk = null;

        for (let obj of this.arrBackgrounds) obj = null;
        this.arrBackgrounds = null;

        this.layerBlockInput = null;

        this.sndBtnClick.stop();
        this.sndBtnClick = null;
        this.sndSelectClick.stop();
        this.sndSelectClick = null;
    }

    close () {
        this.frameSelect.position = this.arrBackgrounds[this.ind].position;
        if (this.callbackButtonImg) this.callbackButtonImg(this.ind);
    }

    setOnButtonImgEvent (func) {
        this.callbackButtonImg = func;
    }

    setOnButtonApplyEvent (func) {
        let self = this;
        this.buttonOk.callback = function() {self.ind = self.indNew; func(self.ind);};
    }

    getCurInd () {
        return this.ind;
    }

    setCurInd (ind) {
        if (ind < this.arrBackgrounds.length) {
            this.ind = this.indNew = ind;
            this.frameSelect.position = this.arrBackgrounds[this.ind].position;
        }
    }
}



// WEBPACK FOOTER //
// ./src/settings.es6